import React from 'react';
import {Button, Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import {left_text, right_text} from "./text";
import img_0 from './images/Header without text.webp'
import img_1 from './images/Portal Image no line.webp'
import img_2 from './images/Curated Image no line.webp'
import img_3 from './images/Reseller Image no line.webp'
import './style.scss'

const ProHome = (props) => {
    return (
        <Layout>
            <Content>
                <Row justify={"center"}>
                    <div className="image-overlay-container">
                        <img src={img_0} alt="Business Ambiance" className="y-background-image"/>
                        <div className="overlay-content">
                            <p className={'pro-h1'}>Elevate your business ambiance</p>
                            <p className={'pro-h2'}>with exquisite artwork</p>
                            <p className="overlay-subtext">Create a captivating atmosphere and transform your business
                                surroundings with our Textura Pro digital canvas.</p>
                            <Button className="learn-more-button"
                                    onClick={() =>
                                        window.location.href = '/business/textura-pro'
                                    }>
                                Learn more
                            </Button>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"} style={{
                    columnGap: '4rem',
                    margin: '-12rem 0 0 0'
                }}>
                    <Col lg={8}>
                        {left_text.map((txt, idx) =>
                            <p className={'pro-home-txt'} key={idx}>
                                {txt}
                            </p>
                        )}
                    </Col>
                    <Col lg={8}>
                        {right_text.map((txt, idx) =>
                            <p className={'pro-home-txt'} key={idx}>
                                {txt}
                            </p>
                        )}
                    </Col>
                </Row>
                <Row justify={"center"} className={'j-section'}>
                    <img src={img_1} className={'j-img'}></img>
                    <div className="j-text-overlay">
                        <p className={'j-h1'}>Vieunite Pro Portal</p>
                        <div className="j-white-line"></div>
                        <p className={'j-txt'}>Our curated collection of artwork enables you to tailor your canvases to
                            your brand, theme,
                            or even individual guest preferences. The Textura allows for the seamless integration of
                            your unique artistic vision.</p>
                        <Button
                            onClick={_ =>
                                window.location.href = '/business/prologin'}
                            className="j-overlay-button">
                            Learn more
                        </Button>
                    </div>
                </Row>
                <Row justify={"center"} className={'j-section'}>
                    <img src={img_2} className={'j-img'}></img>
                    <div className="j-text-overlay">
                        <p className={'j-h1'}>Curated Collections</p>
                        <div className="j-white-line"></div>
                        <p className={'j-txt'}>In the world of hospitality, ambiance is everything. It's the first impression your guests receive, setting the stage for unforgettable experiences. Introducing the Textura digital canvas – a cutting-edge solution to transform your hotel, restaurant or business environment.</p>
                        <Button
                            onClick={_ =>
                                window.location.href = '/business/textura-pro'}
                            className="j-overlay-button">
                            Learn more
                        </Button>
                    </div>
                </Row>

                <Row justify={"center"} className={'j-section'}>
                    <img src={img_3} className={'j-img'}></img>
                    <div className="j-text-overlay">
                        <p className={'j-h1'}>Become a Reseller Partner</p>
                        <div className="j-white-line"></div>
                        <p className={'j-txt'}>Discover the benefits of becoming a reseller for the Textura digital canvas. Elevate your business, captivate your customers and lead the way in visual storytelling. Partner with Vieunite Pro to access competitive pricing, marketing support and exclusive product offerings.</p>
                        <Button
                            onClick={_ =>
                                window.location.href = '/business/textura-pro'}
                            className="j-overlay-button">
                            Contact us
                        </Button>
                    </div>
                </Row>
            </Content>
        </Layout>
    )
}

export default ProHome;
